import script from "./ContainerMsgRDG.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerMsgRDG.vue?vue&type=script&setup=true&lang=js"

import "./ContainerMsgRDG.vue?vue&type=style&index=0&id=6fc64255&lang=css"

const __exports__ = script;

export default __exports__